import parse from 'html-react-parser';
import { FC } from 'react';
import style from './prepaidTermsStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

interface PrepaidTermsProps {
  html?: string;
}
export const PrepaidTerms: FC<PrepaidTermsProps> = ({ html }) => {
  if (!html) return <></>;
  return (
    <RoundSheet>
      <div className={style['container']}>{parse(html)}</div>
    </RoundSheet>
  );
};
